module.exports = __webpack_public_path__ + "img/cbiaLogo.fa3acec9.png";